class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);
// ─── Free Shipping Progress Bar ───────────────────────────────────────────────
(function () {
  const FREE_SHIPPING_CENTS = 19900; // 199 in the cart's currency (A$199, US$199, GBP 199 etc)

  const COLORS = {
    under30:  '#e95144',
    under60:  '#69c69c',
    under100: '#69c69c',
    complete: '#69c69c',
  };

  function getProgressColor(pct) {
    if (pct >= 100) return COLORS.complete;
    if (pct >= 60)  return COLORS.under100;
    if (pct >= 30)  return COLORS.under60;
    return COLORS.under30;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0);
  }

  function updateFreeShippingBar(cartTotalCents) {
    const bars = document.querySelectorAll('[data-free-shipping-wrapper]');
    if (!bars.length) return;

    const pct       = Math.min((cartTotalCents / FREE_SHIPPING_CENTS) * 100, 100);
    const remaining = FREE_SHIPPING_CENTS - cartTotalCents;
    const achieved  = cartTotalCents >= FREE_SHIPPING_CENTS;

    bars.forEach(function (bar) {
      const progressWrap = bar.querySelector('[data-shipping-progress]');
      const meter        = bar.querySelector('[data-free-shipping-progress-meter]');
      const message      = bar.querySelector('[data-shipping-message]');

      if (progressWrap) {
        cartTotalCents === 0
          ? progressWrap.classList.add('progress-hidden')
          : progressWrap.classList.remove('progress-hidden');
      }

      if (meter) {
        meter.style.width           = pct + '%';
        meter.style.backgroundColor = getProgressColor(pct);
        meter.style.transition      = 'width 0.4s ease, background-color 0.4s ease';
      }

      if (message) {
        if (achieved) {
          message.textContent = "🎉 You've unlocked free shipping!";
          message.style.color = COLORS.complete;
        } else if (cartTotalCents === 0) {
          message.textContent = 'Add ' + formatMoney(FREE_SHIPPING_CENTS) + ' to your cart for free shipping.';
          message.style.color = '';
        } else {
          message.textContent = "You're " + formatMoney(remaining) + ' away from free shipping!';
          message.style.color = '';
        }
      }
    });
  }

  function refreshFreeShippingBar() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateFreeShippingBar(cart.total_price); })
      .catch(function (e) { console.warn('[FreeShipping] cart.js error', e); });
  }

  document.addEventListener('DOMContentLoaded', refreshFreeShippingBar);

  document.addEventListener('click', function (e) {
    if (e.target && (
      e.target.closest('[data-open-cart-sidebar]') ||
      e.target.closest('.cart-icon') ||
      e.target.closest('[data-cart-icon-bubble]') ||
      e.target.closest('a[href="/cart"]')
    )) {
      setTimeout(refreshFreeShippingBar, 150);
    }
  });

  document.addEventListener('cart:updated', refreshFreeShippingBar);
  document.addEventListener('cart:refresh', refreshFreeShippingBar);

  const _fetch = window.fetch;
  window.fetch = function () {
    return _fetch.apply(this, arguments).then(function (response) {
      const url = (arguments[0] && (arguments[0].url || arguments[0])) || '';
      if (typeof url === 'string' && (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update')
      )) {
        setTimeout(refreshFreeShippingBar, 300);
      }
      return response;
    });
  };
})();
// ─────────────────────────────────────────────────────────────────────────────
